import React from 'react';
import NoteCardSkeletonLoader from './NoteCardSkeletonLoader';

export default {
  title: 'Components/LoadingSkeletons/NoteCardSkeletonLoader',
  component: NoteCardSkeletonLoader,
  parameters: {
    layout: 'centered',
  },
  tags: ['autodocs'],
  argTypes: {
    shouldEnableAnimation: {
      control: { type: 'boolean' },
      description: 'Controls the shouldEnableAnimation prop. By default, it is set to false to keep animations disabled. Set this value to true to enable animations.',
      table: {
        type: { summary: 'boolean' },
        defaultValue: { summary: false },
      },
    },
    UsageHint: {
      description: 'Usage example: `[...Array(9)].map((_, index) => <NoteCardSkeletonLoader key={index} />)`',
    },
    skeletonHeight: {
      control: { type: 'number' },
      description: 'Specifies the height of the skeletons for each line of text.',
      table: {
        type: { summary: 'number' },
        defaultValue: { summary: 16 },
      },
    },
    skeletonTopBarHeight: {
      control: { type: 'number' },
      description: 'Specifies the height of the top bar that mimics the colored priority strip.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: 8 },
      },
    },
    skeletonSiteNameWidth: {
      control: { type: 'text' },
      description: 'Sets the width of the skeleton placeholder for the site name text.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '70%' },
      },
    },
    skeletonStatusLabelWidth: {
      control: { type: 'text' },
      description: 'Sets the width of the skeleton placeholder for the status label text.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '18%' },
      },
    },
    skeletonStatusValueWidth: {
      control: { type: 'text' },
      description: 'Sets the width of the skeleton placeholder for the status value text.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '25%' },
      },
    },
    skeletonTitleWidth: {
      control: { type: 'text' },
      description: 'Sets the width of the skeleton placeholder for the note title.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '60%' },
      },
    },
    skeletonDateWidth: {
      control: { type: 'text' },
      description: 'Sets the width of the skeleton placeholder for the date.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '30%' },
      },
    },
    skeletonContentFirstLineWidth: {
      control: { type: 'text' },
      description: 'Sets the width of the first skeleton line of the note content.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '100%' },
      },
    },
    skeletonContentMiddleLineWidth: {
      control: { type: 'text' },
      description: 'Sets the width of the middle skeleton lines of the note content.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '90%' },
      },
    },
    skeletonContentLastLineWidth: {
      control: { type: 'text' },
      description: 'Sets the width of the last skeleton line of the note content.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '70%' },
      },
    },
  },
};

const Template = (args) => (
  <div className="w-109">
    <NoteCardSkeletonLoader {...args} />
  </div>
);

export const Default = Template.bind({});
Default.args = {
  skeletonHeight: 16,
  skeletonTopBarHeight: 8,
  skeletonSiteNameWidth: '70%',
  skeletonStatusLabelWidth: '18%',
  skeletonStatusValueWidth: '25%',
  skeletonTitleWidth: '60%',
  skeletonDateWidth: '30%',
  skeletonContentFirstLineWidth: '100%',
  skeletonContentMiddleLineWidth: '90%',
  skeletonContentLastLineWidth: '70%',
};

export const SmallSkeletonLoader = Template.bind({});
SmallSkeletonLoader.args = {
  skeletonHeight: 12,
  skeletonTopBarHeight: 6,
  skeletonSiteNameWidth: '60%',
  skeletonStatusLabelWidth: '16%',
  skeletonStatusValueWidth: '22%',
  skeletonTitleWidth: '50%',
  skeletonDateWidth: '25%',
  skeletonContentFirstLineWidth: '90%',
  skeletonContentMiddleLineWidth: '80%',
  skeletonContentLastLineWidth: '60%',
};

export const LargeSkeletonLoader = Template.bind({});
LargeSkeletonLoader.args = {
  skeletonHeight: 24,
  skeletonTopBarHeight: 10,
  skeletonSiteNameWidth: '80%',
  skeletonStatusLabelWidth: '20%',
  skeletonStatusValueWidth: '30%',
  skeletonTitleWidth: '70%',
  skeletonDateWidth: '40%',
  skeletonContentFirstLineWidth: '100%',
  skeletonContentMiddleLineWidth: '95%',
  skeletonContentLastLineWidth: '80%',
};
